<template>
  <div class="bg-[#F3F5F6] testimonial ">
    <div class="container mx-auto px-3 lg:py-16 py-10 flex flex-col items-center">
      <div class="text-center text-4xl font-bold font-primary lg:py-3 py-2">
        FAQS
      </div>
      <div class="lg:w-1/2 text-center lg:py-4 py-2 text-grey ">Here are some frequently asked questions. If you have any
        additional questions, Please reach us on the given number or fill out a query form.</div>

      <div class="w-full flex items-center flex-col">
        <div v-for="(item, i) in faqs" :key="i" class="rounded-sm bg-white my-3 p-3 lg:max-w-[60%]">
          <div :class="item.open ? 'faq open' : 'faq'">
            <div class="question font-semibold hover:cursor-pointer hover:bg-slate-200 py-3 px-2" @click="toggleOpen(i)">
              {{ item.question }}
            </div>
            <div class=" answer px-2 text-grey">{{ item.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
const faqs = ref([
  {
    question: "What services does Gill Brother provide?",
    answer: "Gill Brother provides a wide range of heating and plumbing services, including installation, repair, and maintenance of heating systems, water heaters, boilers, plumbing fixtures, and more.",
    open: false,
  },
  {
    question: "How do I schedule a service appointment?",
    answer: "Scheduling a service appointment with Gill Brother is easy. Simply give us a call or fill out the contact form on our website, and our friendly team will assist you in scheduling a convenient appointment.",
  },
  {
    question: "Are your technicians certified and experienced?",
    answer: "Yes, our technicians are certified professionals with years of experience in the heating and plumbing industry. They have the expertise to handle various heating and plumbing issues efficiently and effectively.",
    open: false,
  },
  {
    question: "Do you offer emergency services? ",
    answer: "Yes, we understand that emergencies can occur outside of regular business hours. That's why Gill Brother offers 24/7 emergency services for heating and plumbing issues. You can rely on us to respond promptly and address your emergency needs. ",
    open: false,
  },
  {
    question: "Can you help with water heater installations and repairs? ",
    answer: "Absolutely! Gill Brother specializes in water heater installations, repairs, and replacements. Whether you need a new water heater or repairs for an existing one, our technicians have you covered. ",
    open: false,
  },
  {
    question: "Do you work with both residential and commercial clients? ",
    answer: "Yes, we provide heating and plumbing services to both residential and commercial clients. Whether you need assistance with your home or your business, we have the expertise to handle your project. ",
    open: false,
  },
  {
    question: "What areas do you serve? ",
    answer: "Gill Brother serves Peel Region, York Region, Toronto Region and Halton Region. We strive to reach as many customers as possible, so please contact us to check if we cover your specific location. ",
    open: false,
  },
  {
    question: "Do you offer maintenance plans for heating systems? ",
    answer: "Yes, we offer maintenance plans to help keep your heating system in optimal condition. Our maintenance plans include regular inspections, cleanings, and tune-ups, ensuring efficient performance and preventing potential issues.",
    open: false,
  },
]);
const toggleOpen = (index) => {
  faqs.value = faqs.value.map((faq, i) => {
    if (index === i) {
      faq.open = !faq.open;
    }
    return faq;
  });
};
</script>
<style scoped>
.faq .question {
  position: relative;
  font-size: 18px;
  transition: all 0.3s linear;
}

.faq .question::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%) rotate(0deg);
  width: 15px;
  height: 15px;
  background-image: url("../../assets//v-1.1/Icons/down-arrow.svg");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all 0.2s linear;
}

.faq.open .question {
  margin-bottom: 5px;
  transition-duration: 0.5s;
}

.faq.open .question::after {
  transform: translateY(-50%) rotate(90deg);
}

.faq .answer {
  font-size: 18px;
  opacity: 0;
  max-height: 0px;
  overflow-y: hidden;
  transition: all 0.4s linear;
}

.faq.open .answer {
  opacity: 1;
  max-height: 100%;
}
</style>